export default {
    contact: {
        guide: "Let our Will specialists guide you through the inevitable. Whether you're just beginning to think about writing your Will, or you're ready to create a legally binding plan for your estate, we're here to help. At NobleWills, our team of estate planning experts is dedicated to ensuring your Will aligns with your intentions and stands the test of time.",
        emailUs: 'Email us',
        email: 'Email',
        emailDescription: 'Prefer using email? Click here to get in touch.',
        chat: 'Chat',
        chatWith: 'Chat with us',
        chatNow: 'Chat now? Click here to instantly speak with our specialists.',
        firstName: 'First Name',
        lastName: 'Last Name',
        messageSent: '',
        getBack: '',
        phone: 'Phone',
        phoneNumber: 'Phone Number',
        phoneCall: 'Call us',
        phoneDescription: 'Already on your phone? Why not just give us a quick call.',
        name: 'Name',
        message: 'Message',
        messagePlaceholder: 'Hello, I am interested in writing a Will.',
        callNow: 'Call Now',
        country: 'Country',
        countryOf: 'Country of Residence',
        countrySelect: 'Select country',
        stay: 'Stay up to date',
        stayBody:
            'We would periodically send out newsletters to notify you of new products, service updates, partnerships, and more. You can unsubscribe at anytime if you wish no to longer receive anything from us.',
        join: 'Join our newsletter',
        whatsapp: 'WhatsApp',
        whatsappUs: 'WhatsApp us',
        whatsappDescription: 'Already on your phone? Why not just WhatsApp us.',
        mailList: 'Please add me to your mailing list!',
        receiveNewsletter: 'I would like to receive email newsletters.',
        welcome: 'Welcome!',
        thankYou: 'Thank you!',
    },
};
